import onlineCourse from 'iztech-design-system-neo/dist/system/i18n/vi/onlineCourse'

const DETAIL = {
	MSG_NO_LESSON: 'This course currently has no lesson!',
}

export default {
  ...onlineCourse,
  DETAIL,
}